export default __webpack_public_path__ + "static/media/RedVelvet.5fe20243.png";